export default __webpack_public_path__ + "images/9Q.27b6cba.png";